import _toConsumableArray from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "tui-search-more-list"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  "class": "list-item-title"
};
import { ref, watch, onMounted } from "../../../adapter-vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import TUICore, { TUIConstants } from "@tencentcloud/tui-core";
import Icon from "../../common/Icon.vue";
import searchMoreSVG from "../../../assets/icon/search-more.svg";
import { isUniFrameWork } from "../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    searchType: {
      type: String,
      "default": "global",
      validator: function validator(value) {
        return ["global", "conversation"].includes(value);
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var searchMoreRef = ref();
    var isListShow = ref(false);
    var toggleMore = function toggleMore() {
      isListShow.value = !isListShow.value;
    };
    var extensionList = ref([]);
    var handleMenu = function handleMenu(item) {
      var _item$listener = item.listener,
        listener = _item$listener === void 0 ? {
          onClicked: function onClicked() {}
        } : _item$listener;
      listener.onClicked(item);
      toggleMore();
    };
    onMounted(function () {
      // extensions
      extensionList.value = _toConsumableArray(TUICore.getExtensionList(TUIConstants.TUISearch.EXTENSION.SEARCH_MORE.EXT_ID));
      // hide conversation header
      TUICore.callService({
        serviceName: TUIConstants.TUIConversation.SERVICE.NAME,
        method: TUIConstants.TUIConversation.SERVICE.METHOD.HIDE_CONVERSATION_HEADER,
        params: {}
      });
    });
    watch(function () {
      return isListShow.value;
    }, function () {
      if (isListShow.value) {
        onClickOutside(searchMoreRef.value);
        TUIStore.update(StoreName.CUSTOM, "currentSearchingStatus", {
          isSearching: false,
          searchType: props.searchType
        });
      }
    });
    // 全局搜索dialog-点击外侧关闭
    // click outside
    var clickOutside = false;
    var clickInner = false;
    var onClickOutside = function onClickOutside(component) {
      if (isUniFrameWork) {
        return;
      }
      document.addEventListener("click", onClickDocument);
      (component === null || component === void 0 ? void 0 : component.addEventListener) && (component === null || component === void 0 ? void 0 : component.addEventListener("click", onClickTarget));
    };
    var removeClickListener = function removeClickListener(component) {
      if (isUniFrameWork) {
        return;
      }
      document.removeEventListener("click", onClickDocument);
      (component === null || component === void 0 ? void 0 : component.removeEventListener) && (component === null || component === void 0 ? void 0 : component.removeEventListener("click", onClickTarget));
    };
    var onClickDocument = function onClickDocument() {
      clickOutside = true;
      if (!clickInner && clickOutside) {
        isListShow.value = false;
      }
      clickOutside = false;
      clickInner = false;
    };
    var onClickTarget = function onClickTarget() {
      clickInner = true;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": "tui-search-more",
        ref_key: "searchMoreRef",
        ref: searchMoreRef
      }, [_createElementVNode("div", {
        "class": "more",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return toggleMore();
        })
      }, [_createVNode(Icon, {
        "class": "more-icon",
        file: _unref(searchMoreSVG),
        width: "28px",
        height: "28px"
      }, null, 8, ["file"])]), _unref(isListShow) ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extensionList), function (extension, index) {
        return _openBlock(), _createElementBlock("li", {
          "class": "list-item",
          key: index,
          onClick: function onClick($event) {
            return handleMenu(extension);
          }
        }, [extension.icon ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          "class": "list-item-icon",
          file: extension.icon
        }, null, 8, ["file"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, _toDisplayString(extension.text), 1)], 8, _hoisted_2);
      }), 128))])) : _createCommentVNode("", true)], 512);
    };
  }
});